import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledDropdown } from './Dropdown.styles';
/**
 * Dropdown is a generic Dialog for contextual content. It is similar to the Popover
 * component, but it doesn't include an arrow nor a close button.
 *
 * Dropdown makes no assumption about the content. Make sure you set appropriate height and width
 * on your content. For a dropdown that focuses on a list of actions, see the Menu component.
 *
 * @extends Dialog
 * @related [`Menu`, `Popover`]
 * @since 7.28.0
 */
export var Dropdown = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var content = children;
  if (typeof children === 'function') {
    content = children(props);
  }
  return /*#__PURE__*/React.createElement(StyledDropdown, _extends({
    innerRef: forwardedRef
  }, rest, {
    shouldTakeFocus: false
  }), content);
});
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The dropdown content as a node or a render function.
   *
   * When passing a render function, you get access to the props as the only
   * argument. You can use the `onClose` prop in your render function to signal that the dropdown
   * should be closed.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * @ignore
   */
  closeButton: PropTypes.node,
  /**
   * @ignore
   */
  renderCloseButton: PropTypes.node,
  /**
   * Inherited from the `Dialog` component.
   */
  shouldCloseOnESCKeyPress: PropTypes.bool,
  /**
   * Inherited from the `Dialog` component.
   */
  shouldCloseOnOutsideClick: PropTypes.bool,
  /**
   * Always false, use `Popper` `shouldFocusTriggered` instead.
   *
   * Inherited from the `Dialog` component.
   */
  shouldTakeFocus: PropTypes.bool
} : {};
Dropdown.defaultProps = {
  closeButton: null,
  renderCloseButton: null,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: true,
  shouldTakeFocus: false
};